module.exports = __webpack_public_path__ + "img/multipleClouds.5aba04ad.jpg";